import { render } from "./CajaCierre.vue?vue&type=template&id=54b13df8&scoped=true"
import script from "./CajaCierre.vue?vue&type=script&lang=js"
export * from "./CajaCierre.vue?vue&type=script&lang=js"

import "./CajaCierre.vue?vue&type=style&index=0&id=54b13df8&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b13df8"]])

export default __exports__